import { scoreRules } from './scoreRules';
import { Secret } from '../types/secret';
import { SimpleScore } from '@internal/ui-common';

const calculateScore = (secrets: Secret[]): SimpleScore => {
  const counts = { red: 0, orange: 0, green: 0 };
  secrets.forEach(secret => {
    if (scoreRules.red.rule(secret.ChangedSince)) {
      counts.red++;
    } else if (scoreRules.orange.rule(secret.ChangedSince)) {
      counts.orange++;
    } else {
      counts.green++;
    }
  });
  return counts;
};

export const getSecretsScore = (secrets: Secret[] | undefined): SimpleScore => {
  if (secrets?.length) {
    const score = calculateScore(secrets);
    return score;
  }
  return { red: 0, orange: 0, green: 0 };
};
